import { render, staticRenderFns } from "./body-content.vue?vue&type=template&id=15663fb2&"
import script from "./body-content.vue?vue&type=script&lang=js&"
export * from "./body-content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports